import { DocumentMultiReceiptEntity } from '../../../generated-api';
import ocrTypeNameDefinitions from '../../../utils/ocrTypeNameDefinitions';
import { convertMultiReceiptCsv } from '../Receipt/MultiReceipt/convertMultiReceiptCsv';
import { expandMultiReceiptTable } from '../Receipt/MultiReceipt/expandMultiReceiptTable';
import { formDataToEntity } from '../Receipt/MultiReceipt/formDataToEntity';
import { MultiReceiptFormComponent } from '../Receipt/MultiReceipt/MultiReceiptFormComponent';
import { OcrResultPageDefinition } from './types';

const multiReceiptResultPageDefinition: OcrResultPageDefinition<DocumentMultiReceiptEntity> = {
  name: ocrTypeNameDefinitions.multi_receipt,
  tabs: [
    {
      csvColumns: {},
      tableColumns: [],
      tableExpandable: {
        expandedRowRender: expandMultiReceiptTable,
      },
    },
  ],
  formComponent: MultiReceiptFormComponent,
  formDataToEntity: formDataToEntity,
  csvDataConverters: [{ converter: convertMultiReceiptCsv }],
};

export default multiReceiptResultPageDefinition;
